import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "../../components/global/Header";
import ChartBox from "../../components/adminComponents/ChartBox";
import EmailIcon from "@mui/icons-material/Email";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import GroupIcon from "@mui/icons-material/Group";
import SubscriberPieChart from "../../components/adminComponents/SubscriberPieChart";
import BarChart from "../../components/adminComponents/BarChartComp";
import {
  chartBoxSubscriber,
  chartBoxRevenue,
  chartBoxQuery,
} from "../../data/DashBoardData";
import Error404 from "../../pages/Error404";

const Dashboard = ({ role }) => {
  const [totalRevenue, setTotalRevenue] = useState("...");
  const [totalSubscribers, setTotalSubscribers] = useState("...");
  const [userQueries, setUserQueries] = useState("...");
  const [subscriberData, setSubscriberData] = useState({});

  useEffect(() => {
    fetch("http://localhost:8000/admins/total-revenue")
      .then((response) => response.json())
      .then((data) => setTotalRevenue(data.total_revenue));

    fetch("http://localhost:8000/admins/count-subscribers")
      .then((response) => response.json())
      .then((data) => setTotalSubscribers(data.total_subscribers));

    fetch("http://localhost:8000/feedback/count-feed")
      .then((response) => response.json())
      .then((data) => setUserQueries(data.total_feedbacks));

    fetch("http://localhost:8000/admins/subscriber-by-plan")
      .then((response) => response.json())
      .then((data) => setSubscriberData(data));
  }, []);

  return (
    <>
      {role === "admin" ? (
        <Box m="2vw">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="DASHBOARD" subTitle="Welcome to your dashboard" />
          </Box>
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          >
            <Box
              gridColumn="span 4"
              border="1px solid var(--color-white-50)"
              backgroundColor={"#201939"}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ChartBox
                title="Total Revenue"
                subtitle={totalRevenue}
                icon={
                  <MonetizationOnIcon
                    sx={{ color: chartBoxRevenue.color, fontSize: "26px" }}
                  />
                }
                chartData={chartBoxRevenue.chartData}
                dataKey={chartBoxRevenue.dataKey}
                Color={chartBoxRevenue.color}
              />
            </Box>
            <Box
              gridColumn="span 4"
              backgroundColor={"#201939"}
              border="1px solid var(--color-white-50)"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ChartBox
                title="Total Subscribers"
                subtitle={totalSubscribers}
                icon={
                  <GroupIcon
                    sx={{ color: chartBoxSubscriber.color, fontSize: "26px" }}
                  />
                }
                chartData={chartBoxSubscriber.chartData}
                dataKey={chartBoxSubscriber.dataKey}
                Color={chartBoxSubscriber.color}
              />
            </Box>
            <Box
              gridColumn="span 4"
              backgroundColor={"#201939"}
              display="flex"
              border="1px solid var(--color-white-50)"
              alignItems="center"
              justifyContent="center"
            >
              <ChartBox
                title="User Queries"
                subtitle={userQueries}
                icon={
                  <EmailIcon
                    sx={{ color: chartBoxQuery.color, fontSize: "26px" }}
                  />
                }
                chartData={chartBoxQuery.chartData}
                dataKey={chartBoxQuery.dataKey}
                Color={chartBoxQuery.color}
              />
            </Box>
            {/* Ensure BarChart and SubscriberPieChart components accept data props */}
            <Box
              gridColumn="span 6"
              gridRow="span 2"
              backgroundColor={"#201939"}
              border="1px solid var(--color-white-50)"
              overflow="auto"
            >
              <BarChart data={subscriberData || []} />
            </Box>
            <Box
              gridColumn="span 6"
              gridRow="span 2"
              border="1px solid var(--color-white-50)"
              backgroundColor={"#201939"}
              overflow="auto"
            >
              <SubscriberPieChart data={subscriberData || {}} />
            </Box>
          </Box>
        </Box>
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default Dashboard;
